import { HIGHLIGHT_AREA_HEIGHT } from '../consts/gallery.consts';

export const getFocusZoomPercentToScroll = (event?: React.MouseEvent<HTMLDivElement>) => {
  if (!event) {
    return 0;
  }

  const box = event.currentTarget.getBoundingClientRect();

  const relativeY = event.clientY - box.top;

  const centeredY = relativeY - HIGHLIGHT_AREA_HEIGHT / 2;

  const maxY = box.height - HIGHLIGHT_AREA_HEIGHT;

  const clampedY = Math.max(0, Math.min(centeredY, maxY));

  const focusPercentToScroll = clampedY / maxY;

  return focusPercentToScroll;
};
